import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import{ NavigationService } from '../../../../../../_services/navigation.service';
import { ActivatedRoute , RouterModule } from '@angular/router';
import { EmailService } from '../../../../../../_services/email/email.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { Router } from '@angular/router';
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreCardComponent, MapfreButtonComponent],
  selector: 'app-request-success',
  templateUrl: './request-success.component.html',
})
export class RequestSuccessComponent implements OnInit {
  loading: boolean;
  requestType: string;
  submitRequestType: string;
  emailAddress: string;
  info: string;
  requestQuestion: boolean;
  isAcmic:boolean;
  policyId: string;

  constructor(
    public route: ActivatedRoute,
    private storageService: StorageServiceObservablesService,
    private emailService: EmailService,
    private navigationService: NavigationService,
    private acmicService:AcmicService,
    private router: Router
  ) { 
    this.loading = true;
    this.requestQuestion = false;
  }
  setRequestTypeAndInfo(reason) {
    this.info = "REFUND_APPROVED";
    this.requestQuestion = false;
    if(reason?.includes('expired check')){
      this.submitRequestType = 'SUBMIT_EXPIRED_CHECK';
    } else if(reason?.includes('Lost check')) {
      this.submitRequestType = 'SUBMIT_LOST_CHECK';
    } else if(reason?.includes('Received uncashed refund letter')) {
      this.submitRequestType = 'SUBMIT_UNCACHED_CHECK';
      this.info = 'UNCASHED_REFUND_LETTER_APPROVED';
    } else {
      if(reason?.includes('Amount')){
        this.requestQuestion = true;
        this.submitRequestType = 'THANKS_SEND_MESSAGE';
      } else {
        this.requestQuestion = false;
        this.submitRequestType = 'refund status request';
      }
    }
  }
  ngOnInit(): void {
    this.isAcmic=this.acmicService.isACMIC();
    this.emailAddress = this.storageService.getUserFromStorage();
    this.policyId = this.route.snapshot.paramMap.get('policyid') || this.route.parent?.snapshot.paramMap.get('policyid') || '';
    this.route.queryParams.subscribe((params) => {
      this.requestType = params['request'];
      if(this.requestType === 'cancellations'){
        this.submitRequestType = 'CANCEL_REQUEST';
      } else if(this.requestType === 'refund'){
        const reason = history.state?.reason
        this.setRequestTypeAndInfo(reason);
      }
      this.loading = false;
    });
  }

  onClickBack(){
    if(this.policyId){
      this.router.navigate(['/billing-new', this.policyId, 'details']);
    }
    else {
      this.navigationService.goBackToRecentUrl(['/contact', '/billing', '/home']);
    }
  }
}
